import { createContext, useState } from "react";
import { useDispatch } from "react-redux";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import { setMetaAction } from "../../../redux/actions/metaActions/metaActions";
import { editSettingAdminService } from "../../../services/adminServices";

export const settingAdminContext = createContext({
  logo: "",
  setLogo: () => {},
  title: "",
  setTitle: () => {},
  phoneNumber: "",
  setPhoneNumber: () => {},
  address: "",
  setAddress: () => {},
  morningShift: "",
  setMorningShift: () => {},
  eveningShift: "",
  setEveningShift: () => {},
  handleEditSetting: () => {},
});

const SettingAdminContext = ({ children }) => {
  const dispatch = useDispatch();

  const [logo, setLogo] = useState("");
  const [title, setTitle] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [morningShift, setMorningShift] = useState("");
  const [eveningShift, setEveningShift] = useState("");

  // Edit Setting
  const handleEditSetting = async (event) => {
    event?.preventDefault();

    const objData = {
      logo,
      title,
      phoneNumber,
      address,
      morningShift,
      eveningShift,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await editSettingAdminService(objData);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        dispatch(setMetaAction());
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <>
      <settingAdminContext.Provider
        value={{
          logo,
          setLogo,
          title,
          setTitle,
          phoneNumber,
          setPhoneNumber,
          address,
          setAddress,
          morningShift,
          setMorningShift,
          eveningShift,
          setEveningShift,
          handleEditSetting,
        }}
      >
        {children}
      </settingAdminContext.Provider>
    </>
  );
};

export default SettingAdminContext;
